import DischargeDetails from './DischargeDetails';

export default DischargeDetails;
